var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27103",
    "data-name": "Group 27103",
    transform: "translate(-1036 -216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26925",
    "data-name": "Group 26925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26914",
    "data-name": "Group 26914",
    transform: "translate(362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26909",
    "data-name": "Group 26909",
    transform: "translate(-893 -41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25269",
    "data-name": "Group 25269",
    transform: "translate(311 -862)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bgCircle",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1256 1119)",
    fill: "#f2f2f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26915",
    "data-name": "Group 26915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26910",
    "data-name": "Group 26910",
    transform: "translate(362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14123",
    "data-name": "Rectangle 14123",
    width: 11,
    height: 11,
    transform: "translate(680 222)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26837",
    "data-name": "Group 26837",
    transform: "translate(1046 222.236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1680",
    "data-name": "Ellipse 1680",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 -0.236)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1681",
    "data-name": "Ellipse 1681",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 3.764)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1682",
    "data-name": "Ellipse 1682",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 7.764)",
    fill: "#396"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsCircle);
export default __webpack_public_path__ + "static/media/dots_circle.852e49cdb5605ff786ac86c8c2a1c84d.svg";
export { ForwardRef as ReactComponent };